"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderEdit = exports.default = void 0;

var _base = require("./base");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _noty = require("noty");

var _react = _interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _SiteNavigation = babelHelpers.interopRequireDefault(require("components/SiteNavigation"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var OrderEdit = /*#__PURE__*/function (_ReactModal) {
  babelHelpers.inherits(OrderEdit, _ReactModal);

  var _super = _createSuper(OrderEdit);

  function OrderEdit(id, props) {
    var _this;

    babelHelpers.classCallCheck(this, OrderEdit);
    _this = _super.call(this, id);
    _this.classList = ['modal', 'modal-full', 'modal-centered-content', 'fade'];
    _this.modalTitleElement = 'h3';
    _this.innerWrapper = false;
    _this.withError = false;
    _this.defaultType = null;
    _this.removeOnHide = true;
    _this.props = null;

    _this.setComponent( /*#__PURE__*/_react.default.createElement(LineItem, _extends({
      modal: babelHelpers.assertThisInitialized(_this)
    }, props)));

    return _this;
  }

  babelHelpers.createClass(OrderEdit, [{
    key: "title",
    get: function get() {
      return "";
    }
  }]);
  return OrderEdit;
}(_base.ReactModal);

exports.OrderEdit = OrderEdit;
var LineItem = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(LineItem, _Component);

  var _super2 = _createSuper(LineItem);

  function LineItem() {
    var _this2$quantity;

    var _this2;

    babelHelpers.classCallCheck(this, LineItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this2, "modal", _descriptor, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "id", _descriptor2, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "image", _descriptor3, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor4, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "brandName", _descriptor5, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "quantity", _descriptor6, babelHelpers.assertThisInitialized(_this2));
    babelHelpers.initializerDefineProperty(_this2, "price", _descriptor7, babelHelpers.assertThisInitialized(_this2));
    _this2.state = {
      quantity: String((_this2$quantity = _this2.quantity) !== null && _this2$quantity !== void 0 ? _this2$quantity : 1),
      loading: false
    };
    return _this2;
  }

  babelHelpers.createClass(LineItem, [{
    key: "setQuantity",
    value: function setQuantity(event) {
      this.setState({
        quantity: event.target.value.replace(/[^0-9]/g, "")
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "overlay-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "order-edit-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "product-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "main-image",
        style: {
          backgroundImage: "url(".concat(this.image, ")")
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "details"
      }, /*#__PURE__*/_react.default.createElement("h3", null, this.title), /*#__PURE__*/_react.default.createElement("p", null, this.brandName), /*#__PURE__*/_react.default.createElement("div", {
        className: "price-quantity"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.formatPrice(this.price)), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("label", {
        for: "quantity"
      }, "Qty"), /*#__PURE__*/_react.default.createElement("input", {
        type: "number",
        className: "form-control",
        value: this.state.quantity,
        onChange: this.setQuantity
      }))))), /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.updateQuantity,
        className: "btn btn-primary" + ('update' == this.state.loading ? " spinning" : ''),
        "data-spin": this.state.loading ? 'true' : void 0
      }, "Update Quantity"), /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.removeFromCart,
        className: "btn btn-secondary" + ('remove' == this.state.loading ? " spinning" : ''),
        "data-spin": this.state.loading ? 'true' : void 0
      }, "Remove Item")));
    }
  }, {
    key: "_runSetQuantity",
    value: function _runSetQuantity(value, load) {
      var _this3 = this;

      if (this.state.loading) return;
      this.setState({
        loading: load
      }, function () {
        (0, _fetch.default)("data/cart/set", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            product: _this3.id,
            quantity: Number(value)
          })
        }).then(function (v) {
          return v.json();
        }).then(function (v) {
          _this3.modal.hide();

          if (load == 'update') (0, _noty.showNotificationText)('Changed quantity of "' + _this3.title + '".');else (0, _noty.showNotificationText)('Removed "' + _this3.title + '".');

          _Cart.default.updateCart();

          _SiteNavigation.default.cartUpdated(); // userProfileUpdated();

        });
      });
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity() {
      this._runSetQuantity(this.state.quantity, 'update');
    }
  }, {
    key: "removeFromCart",
    value: function removeFromCart() {
      this._runSetQuantity(0, 'remove');
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);

      var _amount$split = amount.split('.'),
          _amount$split2 = babelHelpers.slicedToArray(_amount$split, 2),
          whole = _amount$split2[0],
          dec = _amount$split2[1];

      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3));
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }]);
  return LineItem;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "bogus";
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "/images/Product-Images/Chemicals/SDC10358.jpg";
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "Product Title";
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "brandName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "Brand Name";
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "quantity", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "price", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 12.99;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setQuantity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setQuantity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "updateQuantity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "updateQuantity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "removeFromCart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "removeFromCart"), _class.prototype)), _class);
var instance = new OrderEdit('order-edit');
var _default = instance;
exports.default = _default;